import type { DarijaText } from './overlay';
import type { ServiceOverlay } from './service.darija.part1';

const RELIABLE_QUOTE_Q: DarijaText = {
  darija: 'Kifach nakhod devis m3tamad?',
  darija_ar: 'كيفاش ناخد ديفي معتمد؟',
};
const RELIABLE_QUOTE_A: DarijaText = {
  darija: 'Chra7 l-7aja dyalk mzyan, l-mdina, l-9yasat wla tsawer mofida, w mn ba3d qaren bzaf d-devisat w profils mt2akkdin f Bricolat.',
  darija_ar: 'شرح الحاجة ديالك مزيان، المدينة، القياسات ولا تصاور مفيدة، ومن بعد قارن بزاف ديال الديفيات وبروفايلات متأكدين فـ Bricolat.',
};
const faq = [{ q: RELIABLE_QUOTE_Q, a: RELIABLE_QUOTE_A }];

// Darija of src/data/serviceContent.ts (/services/{slug}), part 2.
export const SERVICE_DARIJA_PART2: Record<string, ServiceOverlay> = {
  demenagement: {
    title: { darija: 'Tarhil f lMaghrib', darija_ar: 'الترحيل فالمغرب' },
    metaTitle: {
      darija: 'Morahhil mohtarif f lMaghrib – Devis bla fllous | Bricolat',
      darija_ar: 'مرحل محترف فالمغرب – ديفي بلا فلوس | Bricolat',
    },
    metaDescription: {
      darija: 'Lqa morahhil mohtarif f lMaghrib. Tarhil mahalli w bin l-mdon, naql l-meubles, emballage. Devis bla fllous, mqaddimin mt2akkdin.',
      darija_ar: 'لقا مرحل محترف فالمغرب. ترحيل محلي وبين المدن، نقل الموبل، إمباليج. ديفي بلا فلوس، مقدمين متأكدين.',
    },
    intro: {
      darija: 'Khattat l-tarhil dyalk b rassek mrta7 m3a Bricolat. Lqa morahhil mohtarif w m3tamad l t-tarhil l-mahalli f Casablanca, bin l-mdon bin Rabat w Agadir, wla ay trajet akhor f lMaghrib. Devis bla fllous w wadi7.',
      darija_ar: 'خطط الترحيل ديالك براسك مرتاح مع Bricolat. لقا مرحل محترف ومعتمد للترحيل المحلي فالدار البيضاء، بين المدن بين الرباط وأكادير، ولا أي طراجي آخر فالمغرب. ديفي بلا فلوس وواضح.',
    },
    sections: [
      {
        heading: { darija: 'Khadamat t-tarhil', darija_ar: 'خدمات الترحيل' },
        body: {
          darija: 'Tarhil mahalli, tarhil bin l-mdon, khidma d-l-emballage, naql meubles mnfaridin w monte-meuble l t-twabeq bla ascenseur. Camion mnasb l l-7ajm, manutention b 3ina w fari9 dyal khibra.',
          darija_ar: 'ترحيل محلي، ترحيل بين المدن، خدمة الإمباليج، نقل موبل منفردين ومونت موبل للطوابق بلا أسانسور. كاميو مناسب للحجم، مانيتونسيون بعناية وفريق ديال خبرة.',
        },
      },
      {
        heading: { darija: 'Tamanat t-tarhil f lMaghrib', darija_ar: 'أثمنة الترحيل فالمغرب' },
        body: {
          darija: 'Tarhil studio mahalli : mn 800 MAD. 2 pièces : 1 200 l 2 500 MAD. 3 pièces : 2 000 l 4 000 MAD. Bin l-mdon : 5 l 15 MAD / km zyada 3la t-taman l-asasi.',
          darija_ar: 'ترحيل ستوديو محلي : من 800 MAD. 2 بيس : 1 200 إلى 2 500 MAD. 3 بيس : 2 000 إلى 4 000 MAD. بين المدن : 5 إلى 15 MAD / km زيادة على الثمن الأساسي.',
        },
      },
    ],
    faq: [
      {
        q: { darija: 'Chhal mn nhar qbel khassni n7jez t-tarhil?', darija_ar: 'شحال من نهار قبل خاصني نحجز الترحيل؟' },
        a: { darija: 'L-mithali 2 l 4 sbou3at qbel l t-tarhil l-kbir wla f waqt d-dorwa. L studio wla tarhil mosta3jil, 2 l 5 yyam y9edrou ykfiw.', darija_ar: 'المثالي 2 إلى 4 سباعات قبل للترحيل الكبير ولا فوقت الذروة. للستوديو ولا ترحيل مستعجل، 2 إلى 5 أيام يقدرو يكفيو.' },
      },
    ],
  },
  menuiserie: {
    title: { darija: 'Njjar f d-dar f lMaghrib', darija_ar: 'نجار فالدار فالمغرب' },
    metaTitle: {
      darija: 'Njjar mo2ahhal f lMaghrib – Devis bla fllous | Bricolat',
      darija_ar: 'نجار مؤهل فالمغرب – ديفي بلا فلوس | Bricolat',
    },
    metaDescription: {
      darija: 'Lqa njjar mohtarif f lMaghrib. Tsni3 3la l-9ias, pose d-bibane w nwafed, cuisine équipée, dressing. Devis bla fllous, sna3iyya mt2akkdin.',
      darija_ar: 'لقا نجار محترف فالمغرب. تصنيع على القياس، بوز الأبواب والنوافذ، كوزين إكيبي، درسينغ. ديفي بلا فلوس، صناعية متأكدين.',
    },
    intro: {
      darija: 'Bricolat katrbtek b a7sen njjara f lMaghrib: khchab, aluminium wla PVC. Meuble 3la l-9ias, bab, cuisine équipée wla dressing, s-sna3iyya dyalna kay-tdkhlou f l-mante9a kamla.',
      darija_ar: 'Bricolat كتربطك مع أحسن النجارة فالمغرب: خشب، ألومنيوم ولا PVC. موبل على القياس، باب، كوزين إكيبي ولا درسينغ، الصناعية ديالنا كيتدخلو فالمنطقة كاملة.',
    },
    sections: [
      {
        heading: { darija: 'Khadamat n-njara', darija_ar: 'خدمات النجارة' },
        body: {
          darija: 'Tsni3 meubles 3la l-9ias, pose d-bibane w nwafed, cuisine équipée, parquet, ghita2at l-ard mn khchab w njara 7irafiyya maghribiyya.',
          darija_ar: 'تصنيع موبل على القياس، بوز الأبواب والنوافذ، كوزين إكيبي، باركي، غطاء الأرض من خشب ونجارة حرفية مغربية.',
        },
      },
      {
        heading: { darija: 'Tamanat n-njara f lMaghrib', darija_ar: 'أثمنة النجارة فالمغرب' },
        body: {
          darija: 'Bab dakhili m7ott : 600 l 1 500 MAD. Nafidha PVC double vitrage : 800 l 2 000 MAD / m². Dressing : 2 000 l 6 000 MAD / ml.',
          darija_ar: 'باب داخلي محطوط : 600 إلى 1 500 MAD. نافذة PVC دوبل ڤيتراج : 800 إلى 2 000 MAD / m². درسينغ : 2 000 إلى 6 000 MAD / ml.',
        },
      },
    ],
    faq,
  },
  climatisation: {
    title: { darija: 'Climatiseur w t-takyif f lMaghrib', darija_ar: 'المكيف والتكييف فالمغرب' },
    metaTitle: {
      darija: 'Mrakkeb climatisation f lMaghrib – Devis bla fllous | Bricolat',
      darija_ar: 'مركب كليماتيزاسيون فالمغرب – ديفي بلا فلوس | Bricolat',
    },
    metaDescription: {
      darija: 'Lqa technicien d-l-climatisation f lMaghrib. Tarkib, siyana w dépannage d-l-climatiseur (split, cassette, gainable). Devis bla fllous.',
      darija_ar: 'لقا تيكنيسيان ديال الكليماتيزاسيون فالمغرب. تركيب، صيانة ودبانّاج المكيف (سبليت، كاسيط، غينابل). ديفي بلا فلوس.',
    },
    intro: {
      darija: 'Mn ba3d ma s-sif wlla ysskhon kter w kter f lMaghrib, mohim bzaf tlqa mohtarif d-l-climatisation tthiq fih. Bricolat katrbtek b techniciens m3tamdin.',
      darija_ar: 'من بعد ما الصيف ولا كيسخون كتر وكتر فالمغرب، مهم بزاف تلقى محترف ديال الكليماتيزاسيون تثق فيه. Bricolat كتربطك مع تيكنيسيان معتمدين.',
    },
    sections: [
      {
        heading: { darija: 'Khadamat l-climatisation', darija_ar: 'خدمات الكليماتيزاسيون' },
        body: {
          darija: 'Tarkib climatiseur split, multi-split, cassette wla gainable, siyana sanawiyya, dépannage, tn9iyat l-filtres w tamlia dyal l-ghaz l-mbarrid.',
          darija_ar: 'تركيب مكيف سبليت، مولتي سبليت، كاسيط ولا غينابل، صيانة سنوية، دبانّاج، تنقية الفيلتر وتعمير الغاز المبرد.',
        },
      },
      {
        heading: { darija: 'Tamanat tarkib l-climatisation f lMaghrib', darija_ar: 'أثمنة تركيب الكليماتيزاسيون فالمغرب' },
        body: {
          darija: 'Tarkib 9 000 BTU : 600 l 1 200 MAD. 18 000 BTU : 900 l 1 800 MAD. Siyana : 250 l 500 MAD. Tamlia dyal l-ghaz : 300 l 700 MAD.',
          darija_ar: 'تركيب 9 000 BTU : 600 إلى 1 200 MAD. 18 000 BTU : 900 إلى 1 800 MAD. صيانة : 250 إلى 500 MAD. تعمير الغاز : 300 إلى 700 MAD.',
        },
      },
    ],
    faq,
  },
  soudure: {
    title: { darija: 'Soudeur w ferronnerie f lMaghrib', darija_ar: 'سودور وفيرونيري فالمغرب' },
    metaTitle: {
      darija: 'Soudeur mohtarif f lMaghrib – Devis bla fllous | Bricolat',
      darija_ar: 'سودور محترف فالمغرب – ديفي بلا فلوس | Bricolat',
    },
    metaDescription: {
      darija: 'Lqa soudeur mo2ahhal f lMaghrib l l-bibane l-kbar, l-grilles, rampes, garde-corps w l-haykal l-ma3danya. Devis bla fllous, sna3iyya mt2akkdin.',
      darija_ar: 'لقا سودور مؤهل فالمغرب للأبواب الكبار، الكريل، رامب، ڭارد كور والهياكل المعدنية. ديفي بلا فلوس، صناعية متأكدين.',
    },
    intro: {
      darija: 'Bricolat katrbtek b soudeurs w ferronniers mohtarifin f ga3 l-mdon l-kbar f lMaghrib. Tsni3 3la l-9ias dyal portails, grilles w haykal ma3danya.',
      darija_ar: 'Bricolat كتربطك مع سودورية وفيرونيي محترفين فكاع المدن الكبار فالمغرب. تصنيع على القياس ديال بورطايل، كريل وهياكل معدنية.',
    },
    sections: [
      {
        heading: { darija: 'Khadamat s-soudure w l-ferronnerie', darija_ar: 'خدمات السودور والفيرونيري' },
        body: {
          darija: 'Portails w grilles, rampes w garde-corps, haykal ma3danya, serrurerie, islah l-lo7amat l-mkssra w sbagha dedd s-sada2.',
          darija_ar: 'بورطايل وكريل، رامب وڭارد كور، هياكل معدنية، سيروري، إصلاح اللحامات المكسرة وصباغة ضد الصدأ.',
        },
      },
      {
        heading: { darija: 'Tamanat s-soudure w l-ferronnerie f lMaghrib', darija_ar: 'أثمنة السودور والفيرونيري فالمغرب' },
        body: {
          darija: 'Grille 3adiyya : 400 l 1 200 MAD. Portail coulissant : 3 000 l 8 000 MAD. Rampe : 300 l 800 MAD / ml.',
          darija_ar: 'كريل عادية : 400 إلى 1 200 MAD. بورطايل كوليسان : 3 000 إلى 8 000 MAD. رامب : 300 إلى 800 MAD / ml.',
        },
      },
    ],
    faq,
  },
  'menuiserie-aluminium': {
    title: { darija: 'Njara d-l-aluminium f lMaghrib', darija_ar: 'نجارة الألومنيوم فالمغرب' },
    metaTitle: {
      darija: 'Njjar aluminium f lMaghrib – Devis bla fllous | Bricolat',
      darija_ar: 'نجار ألومنيوم فالمغرب – ديفي بلا فلوس | Bricolat',
    },
    metaDescription: {
      darija: 'Lqa mkhtass f njarat l-aluminium f lMaghrib. Nwafed, bibane, vérandas, volets. Devis bla fllous, sna3iyya mt2akkdin.',
      darija_ar: 'لقا مختص فنجارة الألومنيوم فالمغرب. نوافذ، أبواب، ڤيرانداس، فولي. ديفي بلا فلوس، صناعية متأكدين.',
    },
    intro: {
      darija: 'Kat-qelleb 3la njjar aluminium f lMaghrib? Bricolat katrbtek b sna3iyya mkhtassin f pose w islah d-nwafed, portes-fenêtres, volets w vérandas.',
      darija_ar: 'كتقلب على نجار ألومنيوم فالمغرب؟ Bricolat كتربطك مع صناعية مختصين فبوز وإصلاح النوافذ، بورط فونيطر، فولي وڤيرانداس.',
    },
    sections: [
      {
        heading: { darija: 'Khdayem njarat l-aluminium l-mojouda', darija_ar: 'خدايم نجارة الألومنيوم الموجودة' },
        body: {
          darija: 'Nwafed, baies vitrées, bibane, portes-fenêtres, volets roulants, stores, vérandas, pergolas, cloisons vitrées w vitrines d-l-7wanit.',
          darija_ar: 'نوافذ، باي ڤيتري، أبواب، بورط فونيطر، فولي رولان، ستورات، ڤيرانداس، بيرڭولا، كلوازون ڤيتري وفيترينات الحوانت.',
        },
      },
      {
        heading: { darija: 'Tamanat njarat l-aluminium f lMaghrib', darija_ar: 'أثمنة نجارة الألومنيوم فالمغرب' },
        body: {
          darija: 'Nafidha double vitrage : 1 200 l 3 000 MAD / m². Bab aluminium : 3 500 l 9 000 MAD. Volet roulant : 1 500 l 3 500 MAD.',
          darija_ar: 'نافذة دوبل ڤيتراج : 1 200 إلى 3 000 MAD / m². باب ألومنيوم : 3 500 إلى 9 000 MAD. فولي رولان : 1 500 إلى 3 500 MAD.',
        },
      },
    ],
    faq,
  },
  vitrier: {
    title: { darija: 'Vitrier f d-dar f lMaghrib', darija_ar: 'ڤيتريي فالدار فالمغرب' },
    metaTitle: {
      darija: 'Vitrier f lMaghrib – Tabdil z-zjaj w devis bla fllous | Bricolat',
      darija_ar: 'ڤيتريي فالمغرب – تبديل الزجاج وديفي بلا فلوس | Bricolat',
    },
    metaDescription: {
      darija: 'Lqa vitrier mo2ahhal f lMaghrib. Tabdil zjaj mkssour, double vitrage, mraya. Tadakhhol sari3. Devis bla fllous.',
      darija_ar: 'لقا ڤيتريي مؤهل فالمغرب. تبديل زجاج مكسور، دوبل ڤيتراج، مرايا. تدخل سريع. ديفي بلا فلوس.',
    },
    intro: {
      darija: 'Zjaj mkssour, nafidha khassha tt-beddel wla tarkib double vitrage? Bricolat katrbtek b vitriers mo2ahhalin kay-tdkhlou b sor3a f lMaghrib kamel.',
      darija_ar: 'زجاج مكسور، نافذة خاصها تتبدل ولا تركيب دوبل ڤيتراج؟ Bricolat كتربطك مع ڤيتريية مؤهلين كيتدخلو بسرعة فالمغرب كامل.',
    },
    sections: [
      {
        heading: { darija: 'Tadakhholat l-vitrerie l-mojouda', darija_ar: 'تدخلات الڤيتري الموجودة' },
        body: {
          darija: 'Tabdil zjaj mkssour, double vitrage, zjaj l-aman, mraya 3la l-9ias, zjaj d-vérandas w ta2min mu2aqqat mn ba3d l-kasr.',
          darija_ar: 'تبديل زجاج مكسور، دوبل ڤيتراج، زجاج الأمان، مرايا على القياس، زجاج ديال ڤيرانداس وتأمين مؤقت من بعد الكسر.',
        },
      },
      {
        heading: { darija: 'Tamanat l-vitrerie f lMaghrib', darija_ar: 'أثمنة الڤيتري فالمغرب' },
        body: {
          darija: 'Zjaj bsit : 150 l 350 MAD / m². Double vitrage : 600 l 1 400 MAD / m². Zjaj mqawwa wla mtaba9 : 500 l 1 500 MAD / m².',
          darija_ar: 'زجاج بسيط : 150 إلى 350 MAD / m². دوبل ڤيتراج : 600 إلى 1 400 MAD / m². زجاج مقوى ولا متطابق : 500 إلى 1 500 MAD / m².',
        },
      },
    ],
    faq,
  },
  'platrerie-staff': {
    title: { darija: 'Jbess w Staff f lMaghrib', darija_ar: 'الجبص والستاف فالمغرب' },
    metaTitle: {
      darija: 'Jbess w staff f lMaghrib - Devis bla fllous | Bricolat',
      darija_ar: 'الجبص والستاف فالمغرب - ديفي بلا فلوس | Bricolat',
    },
    metaDescription: {
      darija: 'Lqa 7irafi mkhtass f l-jbess w d-dékoration staff f lMaghrib. Faux plafonds, corniches, moulures, niches w finitions. Devis bla fllous.',
      darija_ar: 'لقا حرفي مختص فالجبص والديكوراسيون ستاف فالمغرب. فو بلافون، كورنيش، مولير، نيش وفينيسيون. ديفي بلا فلوس.',
    },
    intro: {
      darija: 'Kat-qelleb 3la 7irafi mkhtass f l-jbess d-dékoratif, staff wla jbess f lMaghrib? Bricolat katrbtek b mohtarifin l faux plafonds, corniches w finitions 3la l-9ias.',
      darija_ar: 'كتقلب على حرفي مختص فالجبص الديكوراتيف، ستاف ولا جبص فالمغرب؟ Bricolat كتربطك مع محترفين لفو بلافون، كورنيش وفينيسيون على القياس.',
    },
    sections: [
      {
        heading: { darija: 'Khdayem l-jbess w staff l-mojouda', darija_ar: 'خدايم الجبص والستاف الموجودة' },
        body: {
          darija: 'Faux plafonds, retombées dékoratif, corniches, moulures, rosaces, niches f l-7yout, habillages, enduit, lissage w reprises qbel s-sbagha.',
          darija_ar: 'فو بلافون، رتومبي ديكوراتيف، كورنيش، مولير، روزاس، نيش فالحيوط، أبياج، أندوي، ليساج وربريز قبل الصباغة.',
        },
      },
      {
        heading: { darija: 'Tamanat tawjihiyya f lMaghrib', darija_ar: 'أثمنة توجيهية فالمغرب' },
        body: {
          darija: 'Corniche bsita : 40 l 120 MAD / ml. Faux plafond 3adi : 130 l 250 MAD / m2. Staff dékoratif : 150 l 400 MAD / m2.',
          darija_ar: 'كورنيش بسيطة : 40 إلى 120 MAD / ml. فو بلافون عادي : 130 إلى 250 MAD / m2. ستاف ديكوراتيف : 150 إلى 400 MAD / m2.',
        },
      },
    ],
    faq,
  },
  transport: {
    title: { darija: 'Naql l-bada2i3 f lMaghrib', darija_ar: 'نقل البضائع فالمغرب' },
    metaTitle: {
      darija: 'Naql l-bada2i3 f lMaghrib – Devis bla fllous | Bricolat',
      darija_ar: 'نقل البضائع فالمغرب – ديفي بلا فلوس | Bricolat',
    },
    metaDescription: {
      darija: 'Lqa nnaqil mohtarif f lMaghrib l tawsil l-meubles, l-mawad wla l-bada2i3. Camionnette, camion. Devis bla fllous.',
      darija_ar: 'لقا ناقل محترف فالمغرب لتوصيل الموبل، المواد ولا البضائع. كاميونيط، كاميو. ديفي بلا فلوس.',
    },
    intro: {
      darija: 'Kat-7taj camion wla camionnette bach tnqel l-7wayj dyalk, l-mawad wla l-bada2i3 f lMaghrib? Bricolat katrbtek b nnaqila mohtarifin.',
      darija_ar: 'كتحتاج كاميو ولا كاميونيط باش تنقل الحوايج ديالك، المواد ولا البضائع فالمغرب؟ Bricolat كتربطك مع ناقلين محترفين.',
    },
    sections: [
      {
        heading: { darija: 'Khadamat n-naql l-mojouda', darija_ar: 'خدمات النقل الموجودة' },
        body: {
          darija: 'Tawsil l-meubles, naql mawad l-binaa, tawsil e-commerce w l-7wanit, naql bin l-mdon w tawsil express 7asb t-tawaffor.',
          darija_ar: 'توصيل الموبل، نقل مواد البناء، توصيل إيكومرس والحوانت، نقل بين المدن وتوصيل إكسبريس على حسب التوفر.',
        },
      },
      {
        heading: { darija: 'Tamanat n-naql f lMaghrib', darija_ar: 'أثمنة النقل فالمغرب' },
        body: {
          darija: 'Camionnette : 200 l 600 MAD mahalli. Camion 10 m³ : 500 l 1 500 MAD. Camion 20 m³ : 800 l 2 500 MAD. Bin l-mdon : 5 l 12 MAD / km.',
          darija_ar: 'كاميونيط : 200 إلى 600 MAD محلي. كاميو 10 m³ : 500 إلى 1 500 MAD. كاميو 20 m³ : 800 إلى 2 500 MAD. بين المدن : 5 إلى 12 MAD / km.',
        },
      },
    ],
    faq,
  },
  carrelage: {
    title: { darija: 'Carrelage w pose d-l-carreaux f lMaghrib', darija_ar: 'الكارولاج وبوز الكاريو فالمغرب' },
    metaTitle: {
      darija: 'Carreleur f lMaghrib – Pose d-l-carrelage w devis bla fllous | Bricolat',
      darija_ar: 'كاريلور فالمغرب – بوز الكارولاج وديفي بلا فلوس | Bricolat',
    },
    metaDescription: {
      darija: 'Lqa carreleur mo2ahhal f lMaghrib l l-ard, faïence, zellij, salle de bain w cuisine. Devis bla fllous, sna3iyya mt2akkdin.',
      darija_ar: 'لقا كاريلور مؤهل فالمغرب للأرض، فاييانس، زليج، سال دو بان وكوزين. ديفي بلا فلوس، صناعية متأكدين.',
    },
    intro: {
      darija: 'Bricolat katrbtek b carreleurs mohtarifin bach ysawbou wla yjeddou l-carrelage d-chqtek, villa, cuisine, salle de bain, terrasse wla ma7al dyalk f lMaghrib kamel.',
      darija_ar: 'Bricolat كتربطك مع كاريلورية محترفين باش يصوبو ولا يجددو الكارولاج ديال شقتك، فيلا، كوزين، سال دو بان، تراس ولا محل ديالك فالمغرب كامل.',
    },
    sections: [
      {
        heading: { darija: 'Khdayem l-carrelage l-mojouda', darija_ar: 'خدايم الكارولاج الموجودة' },
        body: {
          darija: 'Pose d-l-carrelage f l-ard, faïence f l-7yout, zellij, n-nz3 d-l-carrelage l-9dim, ragréage, étanchéité, tabdil l-carreaux l-mkssrin w terrasses.',
          darija_ar: 'بوز الكارولاج فالأرض، فاييانس فالحيوط، زليج، النزع ديال الكارولاج القديم، راغريياج، إيطانشيتي، تبديل الكاريو المكسرين وتراسات.',
        },
      },
      {
        heading: { darija: 'Tamanat l-carrelage f lMaghrib', darija_ar: 'أثمنة الكارولاج فالمغرب' },
        body: {
          darija: 'Pose bsita : 30 l 70 MAD / m². Grand format : 70 l 120 MAD / m². Faïence : 60 l 100 MAD / m². Dépose : 10 l 25 MAD / m².',
          darija_ar: 'بوز بسيطة : 30 إلى 70 MAD / m². ڭران فورما : 70 إلى 120 MAD / m². فاييانس : 60 إلى 100 MAD / m². ديبوز : 10 إلى 25 MAD / m².',
        },
      },
    ],
    faq,
  },
  serrurerie: {
    title: { darija: 'Serrurerie w dépannage l-9fl f lMaghrib', darija_ar: 'السيروري ودبانّاج القفل فالمغرب' },
    metaTitle: {
      darija: 'Serrurier f lMaghrib – Fat7 l-bab w devis bla fllous | Bricolat',
      darija_ar: 'سيرريي فالمغرب – فتح الباب وديفي بلا فلوس | Bricolat',
    },
    metaDescription: {
      darija: 'Lqa serrurier mo2ahhal f lMaghrib l fat7 l-bab, tabdil l-9fl, blindage w dépannage mosta3jil. Devis bla fllous.',
      darija_ar: 'لقا سيرريي مؤهل فالمغرب لفتح الباب، تبديل القفل، بلاندياج ودبانّاج مستعجل. ديفي بلا فلوس.',
    },
    intro: {
      darija: 'Sarout d-dar 7abssat, l-9fl 3a9, wla bab khass ytt2amman? Bricolat katrbtek b serruriers mohtarifin l d-dépannages l-mosta3jila w t-tarkibat d-l-aman f lMaghrib kamel.',
      darija_ar: 'السروت ديال الدار حبست، القفل عاق، ولا باب خاص يتأمن؟ Bricolat كتربطك مع سيرريية محترفين للدبانّاجات المستعجلة والتركيبات ديال الأمان فالمغرب كامل.',
    },
    sections: [
      {
        heading: { darija: 'Khadamat s-serrurerie l-mojouda', darija_ar: 'خدمات السيروري الموجودة' },
        body: {
          darija: 'Fat7 l-bab, ikhraj s-sarout l-mkssour, tabdil cylindre, serrure multipoints, blindage, barre de sécurité w dépannage mn ba3d s-sariqa.',
          darija_ar: 'فتح الباب، إخراج السروت المكسور، تبديل سيليندر، سيرير مولتي بوان، بلاندياج، بار دو سيكوريتي ودبانّاج من بعد السرقة.',
        },
      },
      {
        heading: { darija: 'Tamanat s-serrurerie f lMaghrib', darija_ar: 'أثمنة السيروري فالمغرب' },
        body: {
          darija: 'Fat7 bsit : 150 l 400 MAD. Sarout mkssour : 150 l 350 MAD. Cylindre 3adi : 200 l 600 MAD. Serrure multipoints : 800 l 2 500 MAD.',
          darija_ar: 'فتح بسيط : 150 إلى 400 MAD. سروت مكسور : 150 إلى 350 MAD. سيليندر عادي : 200 إلى 600 MAD. سيرير مولتي بوان : 800 إلى 2 500 MAD.',
        },
      },
    ],
    faq,
  },
};
